import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/billPeriodSelectorStyle';
import { makeStyles } from '@material-ui/core';
import Datetime from 'react-datetime';
import { TextField } from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import moment from 'moment';
import { now } from 'utils/date/getDate';
import { DATE_MONTH_YEAR } from '../../../constants';
import { useSelector } from 'react-redux';
import { getBOMLabels } from 'redux/modules/dynamicLabels/selectors';
import { dark_grey } from 'assets/jss/material-dashboard-pro-react';
import { Period } from 'views/PaymentRequestStatusBOM';

// @ts-ignore
const useStyles = makeStyles(styles);
type ViewMode = 'years' | 'months' | 'days' | 'time';
interface IBillingDateSelector {
	dates: Period;
	setDates: Function;
	setStartDateSelected: Function;
	setEndDateSelected: Function;
	setOpenDatePicker: Function;
	openDatePicker: boolean;
	setAltSelValue: Function;
	startDateSelected: boolean;
	endDateSelected: boolean;
	setBillPeriod?: Function;
	showEndDateTextBox?: boolean;
	viewMode?: ViewMode;
}

export const BillingDateSelector = ({
	dates, //start and end date
	setDates, //function to set start and end dates
	setStartDateSelected, // function to set start date
	startDateSelected, //check if start date is selected
	setEndDateSelected, // function to set end date
	endDateSelected, //check if end date is selected
	setOpenDatePicker, // function to set date picker status
	openDatePicker, // check if date picker is open
	setAltSelValue, //set alternative selct value
	setBillPeriod,
	showEndDateTextBox = true,
	viewMode = 'days',
}: IBillingDateSelector) => {
	const classes = useStyles();
	const labels = useSelector(getBOMLabels);
	const billsListLabels = labels?.billsListLabels || {};
	const BILLS_SEARCHING_LIMIT = billsListLabels?.billsSearchingLimit; // months
	const searchingLimit = moment().subtract(BILLS_SEARCHING_LIMIT, 'months');
	return (
		<div className={showEndDateTextBox ? classes.customDateRangeWrapper : ''}>
			<div className={classes.dateInputWrapper}>
				<TextField
					onClick={() => {
						setStartDateSelected(true);
						setEndDateSelected(false);
						setOpenDatePicker(true);
					}}
					onFocus={(e) => {
						setStartDateSelected(true);
						setEndDateSelected(false);
						setOpenDatePicker(true);
					}}
					onChange={() => {
						setDates({ startDate: '', endDate: dates.endDate })
					}}
					value={moment.isMoment(dates.startDate) ? dates.startDate.format(DATE_MONTH_YEAR) : ''}
					data-testid="start-date"
					id="start-date"
				/>
				<DateRangeIcon htmlColor={dark_grey} />
			</div>
			{showEndDateTextBox && (
				<div className={classes.dateInputWrapper}>
					<TextField
						onClick={() => {
							setStartDateSelected(false);
							setEndDateSelected(true);
							setOpenDatePicker(true);
						}}
						onFocus={(e) => {
							setStartDateSelected(false);
							setEndDateSelected(true);
							setOpenDatePicker(true);
						}}
						value={moment.isMoment(dates.endDate) ? dates.endDate.format(DATE_MONTH_YEAR) : ''}
						onChange={() => {
							setDates({ startDate: dates.startDate, endDate: '' });
						}}
						data-testid="end-date"
					/>
					<DateRangeIcon htmlColor={dark_grey} />
				</div>
			)}
			<div className={classes.billPeriodSelectorWrapper}>
				<Datetime
					data-testId="calendar"
					closeOnSelect={true}
					value={startDateSelected?dates.startDate:dates.endDate}
					renderDay={(props, currentDate) => (
						<td {...props}>
							<div className={classes.cell}>{currentDate.date()}</div>
						</td>
					)}
					open={openDatePicker}
					onChange={(e: any) => {
						setOpenDatePicker(false);
						if (startDateSelected) {
							setDates({ startDate: e, endDate: dates.endDate });
							setAltSelValue(
								() => `${e.format(DATE_MONTH_YEAR)} - ${dates.endDate.format(DATE_MONTH_YEAR)}`
							);
						} else if (endDateSelected) {
							setDates({ startDate: dates.startDate, endDate: e });
							setAltSelValue(
								() => `${dates.startDate.format(DATE_MONTH_YEAR)} - ${e.format(DATE_MONTH_YEAR)}`
							);
						}
						if (setBillPeriod) {
							setBillPeriod('');
						}
					}}
					timeFormat={false}
					isValidDate={(currentDate) => {
						if (dates.startDate && !startDateSelected) {
							return (
								moment(dates.startDate)?.isBefore &&
								moment(dates.startDate)?.isBefore(currentDate, 'day') &&
								currentDate.isSameOrBefore(now)
							);
						}
						return currentDate.isAfter(searchingLimit, 'day') && currentDate.isSameOrBefore(now);
					}}
					//@ts-ignore
					calendarProps={{
						tabIndex: 0,
					}}
					viewMode={viewMode}
				/>
			</div>
		</div>
	);
};
